var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slider" }, [
    _c("input", {
      staticClass: "slider-input",
      class: [_vm.direction],
      attrs: { type: "range", max: _vm.max, min: _vm.min, step: _vm.step },
      domProps: { value: _vm.value },
      on: { change: _vm.handleChange, input: _vm.handleInput },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }